import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TaskStatus } from '../../enums';
import type { GetTaskStatusRep } from '../../services/task-repository';
import type { TaskItem } from '../../types';

@injectable()
export class GetTaskStatusRepImpl implements GetTaskStatusRep {
    constructor(
        // @inject(TaskApi)
        // private _taskApi: TaskApi,
    ) {}

    fetch(): Promise<Pick<TaskItem, 'id' | 'status'>[]> {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(
                    [
                        {
                            id: '1',
                            status: TaskStatus.PROCESSING,
                        },
                        {
                            id: '2',
                            status: TaskStatus.COMPLETED,
                        },
                        {
                            id: '3',
                            status: TaskStatus.FAILED,
                        },
                        {
                            id: '4',
                            status: TaskStatus.PROCESSING,
                        },
                    ],
                );
            }, 1000);
        });
    }
}
